import { gql } from 'src/generated/gql';
import type { GetPopInClinicQueueQuery } from 'src/generated/gql/graphql';

export const GET_POP_IN_CLINIC_QUEUE = gql(`
  query GetPopInClinicQueue {
    staff_getPopInClinicQueue {
      id
      patientId
      patientName
      patientFirstName
      patientLastName
      patientPreferredName
      patientState
      requestType
      status
      requestTime
      adjustedEntryTime
      score
      isStraightforward
    }
  }
`);

export type QueueItem = GetPopInClinicQueueQuery['staff_getPopInClinicQueue'][number];
